export default __webpack_public_path__ + "static/media/qrCodeLogo360.95bfabc7.png";